import { Navigate } from "react-router-dom";
import { useUserProfile } from "@/hooks/useUserProfile";

/**
 * Wraps the default "/" route to redirect client_viewer users
 * to their dedicated portal instead of the admin dashboard.
 */
export function RoleRedirect({ children }: { children: React.ReactNode }) {
  const { data: profile, isLoading } = useUserProfile();

  if (isLoading) return null;

  const roles: string[] = (profile as any)?.user_role
    ?.map((ur: any) => ur.role?.name)
    .filter(Boolean) ?? [];

  // client_viewer users who have NO admin/staff roles go to client portal
  const isClientOnly =
    roles.includes("client_viewer") &&
    !roles.includes("admin") &&
    !roles.includes("cellar_manager") &&
    !roles.includes("cellar_staff");

  if (isClientOnly) {
    return <Navigate to="/portal" replace />;
  }

  return <>{children}</>;
}
